export default "assets/spinner-83e442ad.gif";